import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";

// #root may hold build-time HTML (scripts/prerender.js) for crawlers. createRoot,
// not hydrateRoot, on purpose: it replaces that markup on mount, so per-visitor
// values (UTM-carrying signup links, consent state) can never be left stale by a
// hydration mismatch.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
